<template>
  <div @click="handleCheck" class="checkbox-by">
    <p class="img-box">
      <img :src="imgSrc" alt="" />
    </p>
    <span class="text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'cCheckBox',
  props: ['text', 'checked'],
  data() {
    return {
      zchecked: false,
      imgSrc: require('@/assets/img/checkbox_f.svg')
    };
  },
  model: {
    prop: 'checked',
    event: 'value'
  },
  watch: {
    checked(newVal, oldVal) {
      this.zchecked = newVal;
      if (newVal) {
        this.imgSrc = require('@/assets/img/checkbox_t.svg');
      } else {
        this.imgSrc = require('@/assets/img/checkbox_f.svg');
      }
    }
  },
  methods: {
    handleCheck() {
      if (this.zchecked) {
        this.imgSrc = require('@/assets/img/checkbox_f.svg');
      } else {
        this.imgSrc = require('@/assets/img/checkbox_t.svg');
      }
      this.zchecked = !this.zchecked;
      this.$emit('value', this.zchecked);
    }
  }
};
</script>

<style lang="less"  scoped>
.checkbox-by {
  display: flex;
  height: 0.25rem;
  align-items: center;
  cursor: pointer;
  .img-box {
    display: flex;
    height: 0.24rem;
    cursor: pointer;
    img {
      width: 0.24rem;
      height: 0.24rem;
      pointer-events: none;
      vertical-align: sub;
    }
  }
  .text {
    margin-left: 0.1rem;
    display: inline-block;
    height: 0.24rem;
    font-size: 0.16rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Select/cCheckBox.vue